/* ------------------------------------------------
Import modules
------------------------------------------------ */

// import Watcher from '../classes/watcher';
import HighlightController from '../classes/highlighter';

/* ------------------------------------------------
Page setup
------------------------------------------------ */

// Create a new HighlightController
const Highlighter = new HighlightController();
Watcher.observe('.js-searchable', blocks => {
  // Grab the parameters from the URL
  const parameters = new URLSearchParams(window.location.search);
  // Get the keyword from the URL
  const keyword = parameters.get('keyword');

  // If there is no keyword, return
  if (!keyword) return;

  // Set the keyword in the highlighter
  Highlighter.setTerm(keyword);

  // Loop through all the blocks and highlight them
  blocks.forEach(block => Highlighter.mark(block));
});